[
  {
    "knesset": 18,
    "year": 2009,
    "date": "2009-02-10",
    "party": "Kadima",
    "seats": 28,
    "votes": 758032,
    "voteShare": 0.22469999999999998
  },
  {
    "knesset": 18,
    "year": 2009,
    "date": "2009-02-10",
    "party": "Likud",
    "seats": 27,
    "votes": 729054,
    "voteShare": 0.2161
  },
  {
    "knesset": 18,
    "year": 2009,
    "date": "2009-02-10",
    "party": "Yisrael Beitenu",
    "seats": 15,
    "votes": 394577,
    "voteShare": 0.11699999999999999
  },
  {
    "knesset": 18,
    "year": 2009,
    "date": "2009-02-10",
    "party": "Labor Party",
    "seats": 13,
    "votes": 334900,
    "voteShare": 0.0993
  },
  {
    "knesset": 18,
    "year": 2009,
    "date": "2009-02-10",
    "party": "Shas",
    "seats": 11,
    "votes": 286300,
    "voteShare": 0.0849
  },
  {
    "knesset": 18,
    "year": 2009,
    "date": "2009-02-10",
    "party": "United Torah Judaism",
    "seats": 5,
    "votes": 147954,
    "voteShare": 0.043899999999999995
  },
  {
    "knesset": 18,
    "year": 2009,
    "date": "2009-02-10",
    "party": "Ra'am-Ta'al",
    "seats": 4,
    "votes": 113954,
    "voteShare": 0.0338
  },
  {
    "knesset": 18,
    "year": 2009,
    "date": "2009-02-10",
    "party": "National Union",
    "seats": 4,
    "votes": 112570,
    "voteShare": 0.0334
  },
  {
    "knesset": 18,
    "year": 2009,
    "date": "2009-02-10",
    "party": "Hadash",
    "seats": 4,
    "votes": 112130,
    "voteShare": 0.0332
  },
  {
    "knesset": 18,
    "year": 2009,
    "date": "2009-02-10",
    "party": "Meretz",
    "seats": 3,
    "votes": 99611,
    "voteShare": 0.029500000000000002
  },
  {
    "knesset": 18,
    "year": 2009,
    "date": "2009-02-10",
    "party": "The Jewish Home",
    "seats": 3,
    "votes": 96765,
    "voteShare": 0.0287
  },
  {
    "knesset": 18,
    "year": 2009,
    "date": "2009-02-10",
    "party": "Balad",
    "seats": 3,
    "votes": 83739,
    "voteShare": 0.0248
  },
  {
    "knesset": 19,
    "year": 2013,
    "date": "2013-01-22",
    "party": "Likud Beitenu",
    "seats": 31,
    "votes": 885163,
    "voteShare": 0.2334
  },
  {
    "knesset": 19,
    "year": 2013,
    "date": "2013-01-22",
    "party": "Yesh Atid",
    "seats": 19,
    "votes": 543458,
    "voteShare": 0.1433
  },
  {
    "knesset": 19,
    "year": 2013,
    "date": "2013-01-22",
    "party": "Labor Party",
    "seats": 15,
    "votes": 432118,
    "voteShare": 0.1139
  },
  {
    "knesset": 19,
    "year": 2013,
    "date": "2013-01-22",
    "party": "The Jewish Home",
    "seats": 12,
    "votes": 345985,
    "voteShare": 0.09119999999999999
  },
  {
    "knesset": 19,
    "year": 2013,
    "date": "2013-01-22",
    "party": "Shas",
    "seats": 11,
    "votes": 331868,
    "voteShare": 0.0875
  },
  {
    "knesset": 19,
    "year": 2013,
    "date": "2013-01-22",
    "party": "United Torah Judaism",
    "seats": 7,
    "votes": 195892,
    "voteShare": 0.0516
  },
  {
    "knesset": 19,
    "year": 2013,
    "date": "2013-01-22",
    "party": "Hatnua",
    "seats": 6,
    "votes": 189167,
    "voteShare": 0.0499
  },
  {
    "knesset": 19,
    "year": 2013,
    "date": "2013-01-22",
    "party": "Meretz",
    "seats": 6,
    "votes": 172403,
    "voteShare": 0.0455
  },
  {
    "knesset": 19,
    "year": 2013,
    "date": "2013-01-22",
    "party": "Ra'am-Ta'al",
    "seats": 4,
    "votes": 138450,
    "voteShare": 0.0365
  },
  {
    "knesset": 19,
    "year": 2013,
    "date": "2013-01-22",
    "party": "Hadash",
    "seats": 4,
    "votes": 113439,
    "voteShare": 0.029900000000000003
  },
  {
    "knesset": 19,
    "year": 2013,
    "date": "2013-01-22",
    "party": "Balad",
    "seats": 3,
    "votes": 97030,
    "voteShare": 0.0256
  },
  {
    "knesset": 19,
    "year": 2013,
    "date": "2013-01-22",
    "party": "Kadima",
    "seats": 2,
    "votes": 78974,
    "voteShare": 0.0208
  },
  {
    "knesset": 20,
    "year": 2015,
    "date": "2015-03-17",
    "party": "Likud",
    "seats": 30,
    "votes": 985408,
    "voteShare": 0.23399999999999999
  },
  {
    "knesset": 20,
    "year": 2015,
    "date": "2015-03-17",
    "party": "Zionist Union",
    "seats": 24,
    "votes": 786313,
    "voteShare": 0.1867
  },
  {
    "knesset": 20,
    "year": 2015,
    "date": "2015-03-17",
    "party": "The Joint List",
    "seats": 13,
    "votes": 446583,
    "voteShare": 0.1061
  },
  {
    "knesset": 20,
    "year": 2015,
    "date": "2015-03-17",
    "party": "Yesh Atid",
    "seats": 11,
    "votes": 371602,
    "voteShare": 0.0882
  },
  {
    "knesset": 20,
    "year": 2015,
    "date": "2015-03-17",
    "party": "Kulanu",
    "seats": 10,
    "votes": 315360,
    "voteShare": 0.07490000000000001
  },
  {
    "knesset": 20,
    "year": 2015,
    "date": "2015-03-17",
    "party": "The Jewish Home",
    "seats": 8,
    "votes": 283910,
    "voteShare": 0.0674
  },
  {
    "knesset": 20,
    "year": 2015,
    "date": "2015-03-17",
    "party": "Shas",
    "seats": 7,
    "votes": 241613,
    "voteShare": 0.0574
  },
  {
    "knesset": 20,
    "year": 2015,
    "date": "2015-03-17",
    "party": "Yisrael Beitenu",
    "seats": 6,
    "votes": 214906,
    "voteShare": 0.051
  },
  {
    "knesset": 20,
    "year": 2015,
    "date": "2015-03-17",
    "party": "United Torah Judaism",
    "seats": 6,
    "votes": 210143,
    "voteShare": 0.0499
  },
  {
    "knesset": 20,
    "year": 2015,
    "date": "2015-03-17",
    "party": "Meretz",
    "seats": 5,
    "votes": 165529,
    "voteShare": 0.0393
  },
  {
    "knesset": 21,
    "year": 2019,
    "date": "2019-04-09",
    "party": "Likud",
    "seats": 35,
    "votes": 1140370,
    "voteShare": 0.2646
  },
  {
    "knesset": 21,
    "year": 2019,
    "date": "2019-04-09",
    "party": "Blue and White",
    "seats": 35,
    "votes": 1125881,
    "voteShare": 0.2613
  },
  {
    "knesset": 21,
    "year": 2019,
    "date": "2019-04-09",
    "party": "Shas",
    "seats": 8,
    "votes": 258275,
    "voteShare": 0.0599
  },
  {
    "knesset": 21,
    "year": 2019,
    "date": "2019-04-09",
    "party": "United Torah Judaism",
    "seats": 8,
    "votes": 249049,
    "voteShare": 0.057800000000000004
  },
  {
    "knesset": 21,
    "year": 2019,
    "date": "2019-04-09",
    "party": "Hadash-Ta'al",
    "seats": 6,
    "votes": 193442,
    "voteShare": 0.0449
  },
  {
    "knesset": 21,
    "year": 2019,
    "date": "2019-04-09",
    "party": "Labor Party",
    "seats": 6,
    "votes": 190870,
    "voteShare": 0.0443
  },
  {
    "knesset": 21,
    "year": 2019,
    "date": "2019-04-09",
    "party": "Yisrael Beitenu",
    "seats": 5,
    "votes": 173004,
    "voteShare": 0.0401
  },
  {
    "knesset": 21,
    "year": 2019,
    "date": "2019-04-09",
    "party": "Union of Right-Wing Parties",
    "seats": 5,
    "votes": 159468,
    "voteShare": 0.037000000000000005
  },
  {
    "knesset": 21,
    "year": 2019,
    "date": "2019-04-09",
    "party": "Meretz",
    "seats": 4,
    "votes": 156473,
    "voteShare": 0.0363
  },
  {
    "knesset": 21,
    "year": 2019,
    "date": "2019-04-09",
    "party": "Kulanu",
    "seats": 4,
    "votes": 152756,
    "voteShare": 0.0354
  },
  {
    "knesset": 21,
    "year": 2019,
    "date": "2019-04-09",
    "party": "Ra'am-Balad",
    "seats": 4,
    "votes": 143666,
    "voteShare": 0.0333
  },
  {
    "knesset": 22,
    "year": 2019,
    "date": "2019-09-17",
    "party": "Blue and White",
    "seats": 33,
    "votes": 1151214,
    "voteShare": 0.2595
  },
  {
    "knesset": 22,
    "year": 2019,
    "date": "2019-09-17",
    "party": "Likud",
    "seats": 32,
    "votes": 1113617,
    "voteShare": 0.251
  },
  {
    "knesset": 22,
    "year": 2019,
    "date": "2019-09-17",
    "party": "Joint List (Hadash, Ra'am, Ta'al, Balad)",
    "seats": 13,
    "votes": 470211,
    "voteShare": 0.106
  },
  {
    "knesset": 22,
    "year": 2019,
    "date": "2019-09-17",
    "party": "Shas",
    "seats": 9,
    "votes": 330199,
    "voteShare": 0.07440000000000001
  },
  {
    "knesset": 22,
    "year": 2019,
    "date": "2019-09-17",
    "party": "Yisrael Beitenu",
    "seats": 8,
    "votes": 310154,
    "voteShare": 0.0699
  },
  {
    "knesset": 22,
    "year": 2019,
    "date": "2019-09-17",
    "party": "United Torah Judaism",
    "seats": 7,
    "votes": 268775,
    "voteShare": 0.060599999999999994
  },
  {
    "knesset": 22,
    "year": 2019,
    "date": "2019-09-17",
    "party": "Yamina",
    "seats": 7,
    "votes": 260655,
    "voteShare": 0.0587
  },
  {
    "knesset": 22,
    "year": 2019,
    "date": "2019-09-17",
    "party": "Labor-Gesher",
    "seats": 6,
    "votes": 212782,
    "voteShare": 0.048
  },
  {
    "knesset": 22,
    "year": 2019,
    "date": "2019-09-17",
    "party": "Democratic Camp",
    "seats": 5,
    "votes": 192495,
    "voteShare": 0.0434
  },
  {
    "knesset": 23,
    "year": 2020,
    "date": "2020-03-02",
    "party": "Likud",
    "seats": 36,
    "votes": 1352449,
    "voteShare": 0.29460000000000003
  },
  {
    "knesset": 23,
    "year": 2020,
    "date": "2020-03-02",
    "party": "Blue and White",
    "seats": 33,
    "votes": 1220381,
    "voteShare": 0.2659
  },
  {
    "knesset": 23,
    "year": 2020,
    "date": "2020-03-02",
    "party": "The Joint List",
    "seats": 15,
    "votes": 581507,
    "voteShare": 0.1267
  },
  {
    "knesset": 23,
    "year": 2020,
    "date": "2020-03-02",
    "party": "Shas",
    "seats": 9,
    "votes": 352853,
    "voteShare": 0.07690000000000001
  },
  {
    "knesset": 23,
    "year": 2020,
    "date": "2020-03-02",
    "party": "United Torah Judaism",
    "seats": 7,
    "votes": 274437,
    "voteShare": 0.059800000000000006
  },
  {
    "knesset": 23,
    "year": 2020,
    "date": "2020-03-02",
    "party": "Labor-Gesher-Meretz",
    "seats": 7,
    "votes": 267480,
    "voteShare": 0.0583
  },
  {
    "knesset": 23,
    "year": 2020,
    "date": "2020-03-02",
    "party": "Yisrael Beitenu",
    "seats": 7,
    "votes": 263365,
    "voteShare": 0.0574
  },
  {
    "knesset": 23,
    "year": 2020,
    "date": "2020-03-02",
    "party": "Yamina",
    "seats": 6,
    "votes": 240689,
    "voteShare": 0.0524
  },
  {
    "knesset": 24,
    "year": 2021,
    "date": "2021-03-23",
    "party": "Likud",
    "seats": 30,
    "votes": 1066892,
    "voteShare": 0.2419
  },
  {
    "knesset": 24,
    "year": 2021,
    "date": "2021-03-23",
    "party": "Yesh Atid",
    "seats": 17,
    "votes": 614112,
    "voteShare": 0.1393
  },
  {
    "knesset": 24,
    "year": 2021,
    "date": "2021-03-23",
    "party": "Shas",
    "seats": 9,
    "votes": 316008,
    "voteShare": 0.0717
  },
  {
    "knesset": 24,
    "year": 2021,
    "date": "2021-03-23",
    "party": "Blue and White",
    "seats": 8,
    "votes": 292257,
    "voteShare": 0.0663
  },
  {
    "knesset": 24,
    "year": 2021,
    "date": "2021-03-23",
    "party": "Yamina",
    "seats": 7,
    "votes": 273836,
    "voteShare": 0.0621
  },
  {
    "knesset": 24,
    "year": 2021,
    "date": "2021-03-23",
    "party": "Labor Party",
    "seats": 7,
    "votes": 268767,
    "voteShare": 0.060899999999999996
  },
  {
    "knesset": 24,
    "year": 2021,
    "date": "2021-03-23",
    "party": "United Torah Judaism",
    "seats": 7,
    "votes": 248391,
    "voteShare": 0.056299999999999996
  },
  {
    "knesset": 24,
    "year": 2021,
    "date": "2021-03-23",
    "party": "Yisrael Beitenu",
    "seats": 7,
    "votes": 248370,
    "voteShare": 0.056299999999999996
  },
  {
    "knesset": 24,
    "year": 2021,
    "date": "2021-03-23",
    "party": "Religious Zionism",
    "seats": 6,
    "votes": 225641,
    "voteShare": 0.0512
  },
  {
    "knesset": 24,
    "year": 2021,
    "date": "2021-03-23",
    "party": "The Joint List",
    "seats": 6,
    "votes": 212583,
    "voteShare": 0.0482
  },
  {
    "knesset": 24,
    "year": 2021,
    "date": "2021-03-23",
    "party": "New Hope",
    "seats": 6,
    "votes": 209161,
    "voteShare": 0.047400000000000005
  },
  {
    "knesset": 24,
    "year": 2021,
    "date": "2021-03-23",
    "party": "Meretz",
    "seats": 6,
    "votes": 202218,
    "voteShare": 0.045899999999999996
  },
  {
    "knesset": 24,
    "year": 2021,
    "date": "2021-03-23",
    "party": "Ra'am",
    "seats": 4,
    "votes": 167064,
    "voteShare": 0.0379
  },
  {
    "knesset": 25,
    "year": 2022,
    "date": "2022-11-01",
    "party": "Likud",
    "seats": 32,
    "votes": 1115336,
    "voteShare": 0.2341
  },
  {
    "knesset": 25,
    "year": 2022,
    "date": "2022-11-01",
    "party": "Yesh Atid",
    "seats": 24,
    "votes": 847435,
    "voteShare": 0.1779
  },
  {
    "knesset": 25,
    "year": 2022,
    "date": "2022-11-01",
    "party": "Religious Zionism",
    "seats": 14,
    "votes": 516470,
    "voteShare": 0.1084
  },
  {
    "knesset": 25,
    "year": 2022,
    "date": "2022-11-01",
    "party": "National Unity Party",
    "seats": 12,
    "votes": 432482,
    "voteShare": 0.0908
  },
  {
    "knesset": 25,
    "year": 2022,
    "date": "2022-11-01",
    "party": "Shas",
    "seats": 11,
    "votes": 392964,
    "voteShare": 0.0825
  },
  {
    "knesset": 25,
    "year": 2022,
    "date": "2022-11-01",
    "party": "United Torah Judaism",
    "seats": 7,
    "votes": 280194,
    "voteShare": 0.0588
  },
  {
    "knesset": 25,
    "year": 2022,
    "date": "2022-11-01",
    "party": "Yisrael Beitenu",
    "seats": 6,
    "votes": 213687,
    "voteShare": 0.044800000000000006
  },
  {
    "knesset": 25,
    "year": 2022,
    "date": "2022-11-01",
    "party": "Ra'am",
    "seats": 5,
    "votes": 194047,
    "voteShare": 0.0407
  },
  {
    "knesset": 25,
    "year": 2022,
    "date": "2022-11-01",
    "party": "Hadash-Ta'al",
    "seats": 5,
    "votes": 178735,
    "voteShare": 0.0375
  },
  {
    "knesset": 25,
    "year": 2022,
    "date": "2022-11-01",
    "party": "Labor Party",
    "seats": 4,
    "votes": 175992,
    "voteShare": 0.0369
  }
]